<div class="flex flex-col items-start justify-start px-5 gap-5">
  <span class="font-bold">Qualification:</span>
  <ul class="list-disc list-inside text-lg">
    <li class="mb-2 text-sm">
      A Bachelor’s or Master’s degree in software engineering, computer science, or a related field.
    </li>
  </ul>
</div>